export default __webpack_public_path__ + "static/media/Fauld of the Black Sarcophagus.43a01c69.jpg";